/* GridRefComboboxEditor.js */

"use strict";
const ComboBox = require("@gluenetworks/combobox").Single;
const GridBaseComboBoxEditor = require("./GridBaseComboboxEditor");
const _ = require("lodash");

class GridRefComboBoxEditor extends GridBaseComboBoxEditor {
    constructor(args) {
        super(args);
        this.parentContainer = args.container;
        // this.keyCaptureList = [ Slick.keyCode.UP, Slick.keyCode.DOWN, Slick.keyCode.ENTER ];
        this.comboBox = new ComboBox({allowClear: true});
        this.initialValue = {};
        this.comboBox.setOptions(args.column.options);
        this.field = args.column.field;

        this.parentContainer[0].appendChild(this.comboBox.renderer.rootElement);
        this.grid = args.grid;
        this.fcdColumnDef = args.column.fcdColumnDef;
        this.grid.openingEditor = true;
        setTimeout(() => {
            this.grid.openingEditor = false;
        }, 100);
    }

    static Formatter(row, cell, value, columnDef /*, dataContext */) {
        let refName = "";
        if (!_.isEmpty(value)) {
            let instanceId = _.get(value, "@ref.instance.instanceId");
            if (instanceId) {
                refName =
                    columnDef.fcdColumnDef.instanceMap[instanceId]["@ref"].instance.instanceName;
            }
        }
        let nameElem = document.createElement("div");
        nameElem.innerText = refName;
        nameElem.classList.add("ref_cell_name");
        nameElem.innerText = refName;
        let displayinfo = columnDef.fcdColumnDef.displayinfo;
        nameElem.setAttribute("title", displayinfo.tooltip);

        let launchElem = document.createElement("launch-default-icon-gl");
        launchElem.setAttribute("data-icon", "form.launch");
        launchElem.classList.add("launch-ref");
        let displayElem = document.createElement("div");
        displayElem.classList.add("ref_cell");
        displayElem.appendChild(nameElem);
        displayElem.appendChild(launchElem);
        return displayElem.outerHTML;
    }

    _registerListeners() {
        this.comboBox.on("Value", (this._valueChanged = this._valueChanged.bind(this)));
    }

    _unregisterListeners() {
        this.comboBox.removeListener("Value", this._valueChanged);
    }

    destroy() {
        setTimeout(() => {
            this._unregisterListeners();
            this.comboBox.shutdown();
        });
    }

    show() {
        this.comboBox.renderer.rootElement.focus();
        let clickEvent = new Event("click");
        this.comboBox.renderer.rootElement.dispatchEvent(clickEvent);
    }

    hide() {}

    focus() {}

    loadValue(item) {
        this.initialValue = item[this.field];
        this.comboBox.setValue(this._getIdFromValue(item[this.field]));
        this._registerListeners();
    }

    getValue() {
        return this.fcdColumnDef.instanceMap[this.comboBox.getValue()];
    }

    setValue(value) {
        this.comboBox.setValue(this._getIdFromValue(value));
    }

    serializeValue() {
        return this.getValue();
    }

    applyValue(item, state) {
        item[this.field] = state;
        this.initialValue = state;
    }

    isValueChanged() {
        return !_.isEqual(this.getValue(), this.initialValue);
    }

    validate() {
        return {
            valid: true,
            msg: null,
        };
    }

    _valueChanged() {
        this.grid.getEditController().commitCurrentEdit();
    }

    _getIdFromValue(value) {
        if (!_.isEmpty(value) && !_.isEmpty(value["@ref"])) {
            if (_.has(value, "@ref.instance.instanceId")) {
                return _.get(value, "@ref.instance.instanceId");
            } else {
                console.warn("Could not find data for reference id");
            }
        }
    }
}

module.exports = GridRefComboBoxEditor;
